import(/* webpackMode: "eager" */ "/home/anbums/public_html/shipment/src/app/not-found.tsx");
